import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function AppCard({ app, index }) {
  return (
    <Link
      to={`/apps/${app.slug}`}
      data-testid={`app-card-${app.slug}`}
      className="group block"
    >
      <article className="h-full rounded-2xl border border-slate-800 bg-gradient-to-br from-slate-900/80 to-slate-900/40 p-7 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-blue-500/40 hover:shadow-xl hover:shadow-blue-900/20">
        <div className="flex items-start justify-between gap-3 mb-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400">
              {app.category}
            </p>
            <h3 className="mt-2.5 text-xl font-bold tracking-tight text-white">
              {app.name}
            </h3>
          </div>
          <span
            data-testid={`app-status-${app.slug}`}
            className={`shrink-0 rounded-lg px-3 py-1.5 text-[10px] font-semibold uppercase tracking-wider ${
              app.status === "Featured"
                ? "border border-blue-400/30 bg-blue-950/50 text-blue-300"
                : "border border-slate-700 bg-slate-800/50 text-slate-400"
            }`}
          >
            {app.status}
          </span>
        </div>

        {app.tagline && (
          <p className="mb-4 text-sm font-medium text-blue-200/70 italic">
            "{app.tagline}"
          </p>
        )}

        <p className="text-sm leading-relaxed text-slate-300 line-clamp-3">
          {app.description}
        </p>

        <div className="mt-5 flex flex-wrap gap-2">
          {app.highlights.map((item) => (
            <span
              key={item}
              className="rounded-lg border border-slate-700 bg-slate-800/50 px-3 py-1.5 text-[11px] font-medium text-slate-300"
            >
              {item}
            </span>
          ))}
        </div>

        <div className="mt-6 flex items-center gap-2 text-sm font-semibold text-blue-400 opacity-0 transition-all duration-300 group-hover:opacity-100">
          <span>Learn More</span>
          <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
        </div>
      </article>
    </Link>
  );
}
